import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("puspita_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function imageUrl(url) {
  if (!url) return PLACEHOLDER_IMG;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

export const PLACEHOLDER_IMG =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='600' height='600' viewBox='0 0 600 600'><rect width='600' height='600' fill='#EFE9DD'/><g fill='none' stroke='#B9AE98' stroke-width='10' stroke-linecap='round'><path d='M300 360 V480'/><path d='M300 360 c-60 -10 -90 -60 -80 -120 c50 10 80 50 80 120z'/><path d='M300 360 c60 -10 90 -60 80 -120 c-50 10 -80 50 -80 120z'/><circle cx='300' cy='230' r='60'/></g><text x='300' y='545' text-anchor='middle' font-family='serif' font-size='28' fill='#8E8470'>Puspita Florist</text></svg>`
  );

export function formatRupiah(n) {
  return `Rp ${new Intl.NumberFormat("id-ID").format(n || 0)}`;
}
